/**
 * トップの「MORE」で、続きの商品をその場に足す（クライアント要望・2026-09-03）。
 *
 * それまではコレクションページへのリンクだったので、押すと一覧の先頭
 * （トップ表示順の1件目）に戻ってしまっていた。BASE時代と同じく
 * 「押したところから続きが出る」形にする。
 *
 * 仕組み:
 *   セクション側が {% paginate %} で出しているので、
 *   同じURLに ?page=N&section_id=<id> を付けて取り直すと、そのページぶんの
 *   セクションHTMLだけが返る（Section Rendering API）。
 *   そこからカードだけ抜いて末尾へ足し、次ページのURLをボタンに持ち直す。
 *
 * 守ること:
 *   - JSが動かない／取得に失敗したときは、リンクのまま素直に遷移させる。
 *     preventDefault は取得に成功する見込みが立つ場合だけ
 *   - 二重クリックで同じページを2回足さない
 */
(function () {
  var LOADING = 'is-loading';

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-sk-more]');
    if (!btn) return;

    var next = btn.dataset.next;
    var sectionId = btn.dataset.section;
    // 次ページが分からない／古いブラウザでは、素のリンクとして遷移させる
    if (!next || !sectionId || !window.DOMParser || !window.fetch) return;
    if (btn.classList.contains(LOADING)) {
      e.preventDefault();
      return;
    }

    var section = btn.closest('.shopify-section') || document;
    var list = section.querySelector('[data-sk-more-list]');
    if (!list) return;

    e.preventDefault();
    btn.classList.add(LOADING);
    btn.setAttribute('aria-busy', 'true');

    var url;
    try {
      url = new URL(next, window.location.origin);
    } catch (err) {
      btn.classList.remove(LOADING);
      return;
    }
    url.searchParams.set('section_id', sectionId);

    fetch(url.toString(), { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error('more ' + res.status);
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var added = doc.querySelectorAll('[data-sk-more-list] > *');
        if (!added.length) throw new Error('more: empty');

        var frag = document.createDocumentFragment();
        Array.prototype.forEach.call(added, function (node) {
          frag.appendChild(document.importNode(node, true));
        });
        list.appendChild(frag);

        // 次のページがまだあるか。無ければボタンごと畳む
        var nextBtn = doc.querySelector('[data-sk-more]');
        if (nextBtn && nextBtn.dataset.next) {
          btn.dataset.next = nextBtn.dataset.next;
        } else {
          var wrap = btn.closest('.sk-more') || btn;
          wrap.remove();
        }

        // 追加ぶんのお気に入りハートなど、カード内の初期化をやり直す
        document.dispatchEvent(
          new CustomEvent('sekka:products-appended', { detail: { container: list } })
        );
      })
      .catch(function () {
        // 取れなかったときはリンクとして機能させる（一覧ページへ）
        window.location.href = btn.href;
      })
      .finally(function () {
        btn.classList.remove(LOADING);
        btn.removeAttribute('aria-busy');
      });
  });
})();
